import { gql } from 'graphql-request';

export const UPDATE_CONTROL_CARD_DOCUMENT = gql`
  mutation App5182dd71_Document(
    $documentId: String!
    $input: app5182dd71_ControlCard_Update_Input!
  ) {
    app5182dd71_ControlCard {
      update(documentId: $documentId, input: $input) {
        id
      }
    }
  }
`;
